import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import GroupSelectionPage from './pages/GroupSelectionPage.json';
import GroupTrackingPage from './pages/GroupTrackingPage.json';
import GroupMenuBar from './pages/GroupMenuBar.json';
import MachinesFilter from './pages/MachinesFilter.json';
import MapToolsDropdown from './pages/MapToolsDropdown.json';
import MachineStats from './pages/MachineStats.json';
import GroupAnalyticsPage from './pages/GroupAnalyticsPage.json';
import RecentActivity from './pages/RecentActivity.json';
import RecentViolations from './pages/RecentViolations.json';
import UtilizationGraph from './pages/UtilizationGraph.json';
import GroupMachinesPage from './pages/GroupMachinesPage.json';
import ActivityModal from './pages/ActivityModal.json';
import ViolationsModal from './pages/ViolationsModal.json';
import MachineDetailsDrawer from './pages/MachineDetailsDrawer.json';
import MachineInfoTab from './pages/MachineInfoTab.json';
import MachineDocumentsTab from './pages/MachineDocumentsTab.json';
import SendEmailPopover from './pages/SendEmailPopover.json';
import MapTab from './pages/MapTab.json';
import CustomInquiry from './pages/CustomInquiry.json';
import MachineHistoryTab from './pages/MachineHistoryTab.json';
import MachineAlertsTab from './pages/MachineAlertsTab.json';
import AddRequestModal from './pages/AddRequestModal.json';
import GroupReportsPage from './pages/GroupReportsPage.json';
import GroupAlerts from './pages/GroupAlerts.json';
import GroupSettingsPage from './pages/GroupSettingsPage.json';
import SettingsPage from './pages/SettingsPage.json';
import SideBar from './pages/SideBar.json';
import EditMaintenanceHistoryModal from './pages/EditMaintenanceHistoryModal.json';
import LinkOperatorModal from './pages/LinkOperatorModal.json';
import MyQuotationsTab from './pages/MyQuotationsTab.json';
import LiveStat from './pages/LiveStat.json';
import BookMachinesPage from './pages/BookMachinesPage.json';
import LogisticsPage from './pages/LogisticsPage.json';
import GroupAnalyticsNew from './pages/GroupAnalyticsNew.json';
import ButtonKeys from './pages/Buttons.json';
import GroupOperators from './pages/GroupOperators.json';
import ReportsPage from './pages/ReportsPage.json';
import FuelDashboard from './pages/FuelDashboard.json';
import App from './pages/App.json';
import EquipmentType from './pages/EquipmentType.json';
var languages = ['en', 'ar', 'hi', 'ur', 'zh', 'nl'];
var languageMap = {};
languages.forEach(function (lang) {
    languageMap[lang] = {};
});
var pages = [
    {
        page: 'GroupSelectionPage',
        translations: GroupSelectionPage,
    },
    {
        page: 'GroupMenuBar',
        translations: GroupMenuBar,
    },
    {
        page: 'GroupTrackingPage',
        translations: GroupTrackingPage,
    },
    {
        page: 'MachinesFilter',
        translations: MachinesFilter,
    },
    {
        page: 'GroupAnalyticsNew',
        translations: GroupAnalyticsNew,
    },
    {
        page: 'MapToolsDropdown',
        translations: MapToolsDropdown,
    },
    {
        page: 'LogisticsPage',
        translations: LogisticsPage,
    },
    {
        page: 'BookMachinesPage',
        translations: BookMachinesPage,
    },
    {
        page: 'LiveStat',
        translations: LiveStat,
    },
    {
        page: 'MachineStats',
        translations: MachineStats,
    },
    {
        page: 'MyQuotationsTab',
        translations: MyQuotationsTab,
    },
    {
        page: 'GroupAnalyticsPage',
        translations: GroupAnalyticsPage,
    },
    {
        page: 'RecentActivity',
        translations: RecentActivity,
    },
    {
        page: 'RecentViolations',
        translations: RecentViolations,
    },
    {
        page: 'UtilizationGraph',
        translations: UtilizationGraph,
    },
    {
        page: 'GroupMachinesPage',
        translations: GroupMachinesPage,
    },
    {
        page: 'LinkOperatorModal',
        translations: LinkOperatorModal,
    },
    {
        page: 'ActivityModal',
        translations: ActivityModal,
    },
    {
        page: 'ViolationsModal',
        translations: ViolationsModal,
    },
    {
        page: 'EditMaintenanceHistoryModal',
        translations: EditMaintenanceHistoryModal,
    },
    {
        page: 'MachineDetailsDrawer',
        translations: MachineDetailsDrawer,
    },
    {
        page: 'MachineInfoTab',
        translations: MachineInfoTab,
    },
    {
        page: 'MachineDocumentsTab',
        translations: MachineDocumentsTab,
    },
    {
        page: 'SendEmailPopover',
        translations: SendEmailPopover,
    },
    {
        page: 'MapTab',
        translations: MapTab,
    },
    {
        page: 'CustomInquiry',
        translations: CustomInquiry,
    },
    {
        page: 'MachineHistoryTab',
        translations: MachineHistoryTab,
    },
    {
        page: 'MachineAlertsTab',
        translations: MachineAlertsTab,
    },
    {
        page: 'AddRequestModal',
        translations: AddRequestModal,
    },
    {
        page: 'GroupReportsPage',
        translations: GroupReportsPage,
    },
    {
        page: 'GroupOperators',
        translations: GroupOperators,
    },
    {
        page: 'GroupAlerts',
        translations: GroupAlerts,
    },
    {
        page: 'GroupSettingsPage',
        translations: GroupSettingsPage,
    },
    {
        page: 'SettingsPage',
        translations: SettingsPage,
    },
    {
        page: 'SideBar',
        translations: SideBar,
    },
    {
        page: 'Buttons',
        translations: ButtonKeys,
    },
    {
        page: 'App',
        translations: App,
    },
    {
        page: 'EquipmentType',
        translations: EquipmentType,
    },
    {
        page: 'ReportsPage',
        translations: ReportsPage,
    },
    {
        page: 'FuelDashboard',
        translations: FuelDashboard,
    },
];
pages.forEach(function (page) {
    languages.forEach(function (lang) {
        languageMap[lang][page.page] = {};
    });
    Object.keys(page.translations).forEach(function (key) {
        languages.forEach(function (lang) {
            if (page.translations[key][lang]) {
                languageMap[lang][page.page][key] =
                    page.translations[key][lang] || '';
            }
            else {
                languageMap[lang][page.page][key] =
                    page.translations[key]['en'] || '';
            }
        });
    });
});
var newInstance = i18next.createInstance();
newInstance.use(initReactI18next).init({
    interpolation: { escapeValue: false },
    lng: 'en',
    defaultNS: 'common',
    resources: {
        en: {
            common: languageMap['en'], // 'common' is our custom namespace
        },
        ar: {
            common: languageMap['ar'],
        },
        hi: {
            common: languageMap['hi'],
        },
        ur: {
            common: languageMap['ur'],
        },
        zh: {
            common: languageMap['zh'],
        },
        nl: {
            common: languageMap['nl'],
        },
    },
});
export var i18n = newInstance;
